"use client";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { subscribeAdsUserInteraction } from "../../../lib/ads-user-interaction-gate";

const AddScriptClientModule = ({ url, isModule = false, uniqueID }) => {
  const pathname = usePathname();
  const scriptRef = useRef(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    if (typeof window === 'undefined') return;

    const loadScript = () => {
      try {
        if (uniqueID) {
          const existingScript = document.getElementById(uniqueID);
          if (existingScript) {
            existingScript.remove();
          }
        }
        
        if (scriptRef.current) {
          scriptRef.current.remove();
        }
        const script = document.createElement("script");
        script.src = url;
        if (uniqueID) {
          script.id = uniqueID;
        }
        if (isModule) {
          script.type = "module";
        }
        script.crossOrigin = "anonymous";
        script.onerror = (error) => {
          console.warn(`Failed to load script: ${url}`, error);
          if (scriptRef.current) {
            scriptRef.current.remove();
          }
        };

        document.head.appendChild(script);
        scriptRef.current = script;
      } catch (error) {
        console.warn(`Error loading script: ${url}`, error);
      }
    };

    let idleId = null;
    let usedIdleCallback = false;

    const scheduleAfterInteraction = () => {
      if (typeof window.requestIdleCallback === "function") {
        usedIdleCallback = true;
        idleId = window.requestIdleCallback(() => loadScript(), { timeout: 2500 });
      } else {
        usedIdleCallback = false;
        idleId = setTimeout(loadScript, 0);
      }
    };

    const unsubscribe = subscribeAdsUserInteraction(scheduleAfterInteraction);

    return () => {
      try {
        unsubscribe();
        if (idleId != null) {
          if (usedIdleCallback && typeof window.cancelIdleCallback === "function") {
            window.cancelIdleCallback(idleId);
          } else {
            clearTimeout(idleId);
          }
        }
        if (uniqueID) {
          const existingScript = document.getElementById(uniqueID);
          if (existingScript) {
            existingScript.remove();
          }
        }
        if (scriptRef.current) {
          scriptRef.current.remove();
        }
      } catch (error) {
        console.warn('Error during script cleanup:', error);
      }
    };
  }, [pathname, url, isModule, uniqueID]);

  if (!isClient) {
    return null;
  }

  return null;
};

export default AddScriptClientModule; 